import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLabel?: string;
  morePath?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLabel,
  morePath,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1.5 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreLabel && morePath && (
        <Link
          to={morePath}
          className="flex items-center gap-1 text-sm font-medium whitespace-nowrap text-primary-600 transition-colors hover:text-primary-800"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}